// Categories follow the client SNB folder structure. See docs/SNB-ASSET-AUDIT.md.
import wassan from "../../Images/client/logos/wassan.jpeg";
import csa from "../../Images/client/logos/csa.jpeg";
import innovation_guild from "../../Images/client/logos/innovation-guild.jpeg";
import techdhara from "../../Images/client/logos/techdhara.svg";
import green_chakra from "../../Images/client/logos/green-chakra.jpg";
import pradan from "../../Images/client/logos/pradan.png";
import akshayakalpa from "../../Images/client/logos/akshayakalpa.jpg";
import puttannaiah_foundation from "../../Images/client/logos/puttannaiah-foundation.png";
import ryss from "../../Images/client/logos/ryss.jpeg";
import skdrdp from "../../Images/client/logos/skdrdp.jpeg";
import rainmatter from "../../Images/client/logos/rainmatter.png";
import villgro from "../../Images/client/logos/villgro.png";
import selco from "../../Images/client/logos/selco.jpeg";
import krishik from "../../Images/client/logos/krishik.jpeg";
import deshpande_startups from "../../Images/client/logos/deshpande-startups.png";
import anvesana from "../../Images/client/logos/anvesana.png";
import acumen from "../../Images/client/logos/acumen.png";

export const partners = [
  { name: "WASSAN", src: wassan },
  { name: "Centre for Sustainable Agriculture", src: csa },
  { name: "Innovation Guild", src: innovation_guild },
  { name: "TechDhara", src: techdhara },
  { name: "Green Chakra", src: green_chakra },
  { name: "PRADAN", src: pradan },
  { name: "Akshayakalpa Organic", src: akshayakalpa },
  { name: "Puttannaiah Foundation", src: puttannaiah_foundation },
  { name: "Rythu Sadhikara Samstha (RYSS)", src: ryss },
  { name: "SKDRDP", src: skdrdp },
];

export const supporters = [
  { name: "Rainmatter", src: rainmatter },
  { name: "Villgro", src: villgro },
  { name: "SELCO Foundation", src: selco },
  { name: "Krishik Agri Business Incubator", src: krishik },
  { name: "Deshpande Startups", src: deshpande_startups },
  { name: "Anvesana", src: anvesana },
  { name: "Acumen", src: acumen },
];
